import React from "react";
import { useCallback, useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { errorToast } from "../../../utils/toast";
import axios from "../../../axios";
import bgImage from "../../../Images/Section (2).png";
import Table from "../../../componant/Table/Table";
import Cell from "../../../componant/Table/cell";
import UserTableControls from "./components/UserTableControls";
import UserNameLink from "./components/UserNameLink";
import { userSortOptions } from "./hooks/useUserTable";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Select,
  Input,
  Textarea,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from "@chakra-ui/react";

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";

import { MdDelete, MdWhatsapp } from "react-icons/md";

import { MdEdit } from "react-icons/md";
import { HiStatusOnline } from "react-icons/hi";
import { GrOverview, GrView } from "react-icons/gr";
import { Tabs, TabList, Tab } from "@chakra-ui/react";
import UserCard from "../../../componant/UserCard/UserCard";
import PaginationNav from "../../../componant/Pagination/Pagination";
import ChangePlanModal from "./components/ChangePlanModal";
import moment from "moment";
import { toast } from "react-toastify";
import { FaWhatsappSquare } from "react-icons/fa";
import DeletePasswordModal from "../../../componant/DeletePasswordModal";
import MobileContactMenu from "../../../componant/MobileContactMenu";

const PAGE_SIZE = 25;

function ActiveUser() {
  const fetchRequestId = React.useRef(0);
  const [, setNewID] = useState(null);
  const [activeTab, setActiveTab] = useState("all");
  const [page, setPage] = useState(1);
 
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const btnRef = React.useRef();
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [filterType, setFilterType] = useState(""); // course | contest | both
const [selectedContest, setSelectedContest] = useState("");
const [contestList, setContestList] = useState([]);
const [users, setUsers] = useState([]);
const [totalUsers, setTotalUsers] = useState(0);
const [totalPages, setTotalPages] = useState(1);
const [apiPageSize, setApiPageSize] = useState(PAGE_SIZE);
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");
const [stats, setStats] = useState({
  allUsers: 0,
  activeUsers: 0,
  newUsers: 0,
});
const {
  isOpen: isPlanOpen,
  onOpen: onPlanOpen,
  onClose: onPlanClose,
} = useDisclosure();
const {
  isOpen: isMessageOpen,
  onOpen: onMessageOpen,
  onClose: onMessageClose,
} = useDisclosure();

const { isOpen, onOpen, onClose } = useDisclosure();
const cancelRef = React.useRef();

const [selectedUser, setSelectedUser] = useState(null);
const [selectedStatusUser, setSelectedStatusUser] = useState(null);
const [statusAction, setStatusAction] = useState("onHold");
const [statusMessageEng, setStatusMessageEng] = useState("");
const [statusMessageHindi, setStatusMessageHindi] = useState("");
const [statusUpdateLoading, setStatusUpdateLoading] = useState(false);
const [currentPlan, setCurrentPlan] = useState("");
const [messageStartDate, setMessageStartDate] = useState("");
const [messageEndDate, setMessageEndDate] = useState("");
const [selectedMessageContest, setSelectedMessageContest] = useState("");
const [userCount, setUserCount] = useState(0);
const [countLoading, setCountLoading] = useState(false);
const {
  isOpen: isStatusOpen,
  onOpen: onStatusOpen,
  onClose: onStatusClose,
} = useDisclosure();
const {
  isOpen: isContestOpen,
  onOpen: onContestOpen,
  onClose: onContestClose,
} = useDisclosure();
  // useEffect(() => {
  //   async function fetchData() {
  //     axios.get("getPaidUsers").then((response) => {
  //       console.log((response?.data))
  //       if (response?.data) {
  //         setData(response?.data?.result);
  //         localStorage.setItem("plans", JSON.stringify(response?.data?.result));
  //       }
  //     });
  //   }
  //   fetchData();
  // }, []);

const fetchUsers = useCallback(async (type, pageNo = 1) => {
  const requestId = ++fetchRequestId.current;
  try {
    let url = "";

    const sortParamMap = {
      latest: "",
      oldest: "",
      amountHigh: "",
      amountLow: "",
      name: "name",
    };

    const params = new URLSearchParams({
      page: pageNo,
      limit: PAGE_SIZE,
      query: search,
      sort: sortParamMap[sortBy] ?? sortBy,
      sortBy,
      filterType,
      contestId: selectedContest,
    });
    if (startDate) params.set("startDate", startDate);
    if (endDate) params.set("endDate", endDate);

    if (type === "all")
      url = `getAllUsers?${params.toString()}`;

    if (type === "paid")
      url = `getPaidUsers?${params.toString()}`;

    if (type === "demo")
      url = `getDemoUsers?${params.toString()}`;

    const res = await axios.get(url);
    if (requestId !== fetchRequestId.current) return;
    const result = res?.data?.result;
    const userList = result?.users || result || [];
    const total =
      result?.totalUsers ??
      result?.total ??
      (Array.isArray(userList) ? userList.length : 0);
    const responseTotalPages =
      Number(result?.totalPages) || Math.max(1, Math.ceil(total / PAGE_SIZE));
    const responsePageSize =
      Number(result?.limit) ||
      (responseTotalPages > 0 ? Math.ceil(total / responseTotalPages) : PAGE_SIZE) ||
      PAGE_SIZE;

    setUsers(Array.isArray(userList) ? userList : []);
    setTotalUsers(total);
    setTotalPages(responseTotalPages);
    setApiPageSize(responsePageSize);

    setStats((previousStats) => ({
      ...previousStats,
      ...(type === "all" && { allUsers: total }),
      ...(type === "paid" && { activeUsers: total }),
      ...(type === "demo" && { newUsers: total }),
    }));
  } catch (err) {
    if (requestId === fetchRequestId.current) {
      errorToast(err.response?.data?.message || "Failed to fetch users");
    }
  }
}, [filterType, search, selectedContest, sortBy, startDate, endDate]);

useEffect(() => {
  setPage(1);
}, [search, sortBy, filterType, selectedContest, startDate, endDate]);

useEffect(() => {
  fetchUsers(activeTab, page);
  // setPage(1);
}, [activeTab, fetchUsers, page]);

const processedData = useMemo(() => {

  let temp = [...users];

  // Sorting
  if (sortBy === "latest") {
    temp.sort(
      (a, b) => new Date(b.createdOn) - new Date(a.createdOn)
    );
  }

  if (sortBy === "oldest") {
    temp.sort(
      (a, b) => new Date(a.createdOn) - new Date(b.createdOn)
    );
  }

  if (sortBy === "amountHigh") {
    temp.sort((a, b) => (b.amount || 0) - (a.amount || 0));
  }

  if (sortBy === "amountLow") {
    temp.sort((a, b) => (a.amount || 0) - (b.amount || 0));
  }

  return temp;
}, [users, sortBy]);

useEffect(() => {
  axios.get("getAllContestForUser").then((res) => {
    console.log("Contest API:", res.data);
    const contests =
      res?.data?.result?.contests || // most common
      res?.data?.result || 
      [];
        console.log()
    setContestList(Array.isArray(contests) ? contests : []);
  });
}, []);

// export 
const exportUsers = async () => {
  try {
    const res = await axios.get(
      `exportUsersByDate?startDate=${startDate}&endDate=${endDate}`
    );

    alert(res.data.message);
  } catch (error) {
    console.log(error);
    alert("Export Failed");
  }
};
const currentStats = useMemo(() => {
  if (activeTab === "all") {
    return {
      title: "All Users",
      count: stats.allUsers,
      gradient: "from-purple-500 to-purple-700",
    };
  }

  if (activeTab === "paid") {
    return {
      title: "Active Users",
      count: stats.activeUsers,
      gradient: "from-teal-500 to-teal-700",
    };
  }

  return {
    title: "New Users",
    count: stats.newUsers,
    gradient: "from-blue-500 to-blue-700",
  };
}, [activeTab, stats]);
const fetchUserCount = async (startDate, endDate) => {
  if (!startDate || !endDate) {
    setUserCount(0);
    return;
  }

  try {
    setCountLoading(true);

    const response = await axios.get(
      `getAllUsers?all=true&startDate=${startDate}&endDate=${endDate}`
    );

    setUserCount(response.data.result.users.length || 0);
  } catch (err) {
    setUserCount(0);
  } finally {
    setCountLoading(false);
  }
};

const sendContestMessage = async () => {
  if (!selectedMessageContest) {
    return errorToast("Please select contest");
  }

  if (!messageStartDate || !messageEndDate) {
    return errorToast("Please select date range");
  }

  try {
    // Date range ke saare users fetch karo
  const response = await axios.get(
  `getAllUsers?all=true&startDate=${messageStartDate}&endDate=${messageEndDate}`
);

const userIds = response.data.result.users.map((user) => user._id);

    if (!userIds.length) {
      return errorToast("No users found");
    }

    const res = await axios.post("/sendContestMessageByDate", {
      contestId: selectedMessageContest,
      userIds,
    });

    alert(res.data.message);
    onMessageClose();
  } catch (err) {
    errorToast(err?.response?.data?.message || "Failed");
  }
};

const handleDeleteUser = async () => {
  try {
    const res = await axios.delete(`/admin/users/${selectedUser}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    toast(res.data.message || "User deleted successfully");
    onClose(); // Close modal
    
    setActiveTab("all");   // All tab select
    setPage(1);            // First page
    fetchUsers("all", 1);  // All users fetch
  } catch (err) {
    errorToast(
      err?.response?.data?.message || "Failed to delete user"
    );
  }
};

 const sendSingleContestMessage = async () => {
  if (!selectedContest) {
    return errorToast("Please select contest");
  }

  try {
    const res = await axios.post(
      "/sendContestWhatsAppMessage",
      {
        contestId: selectedContest,
        userId: [selectedUser._id], // only one user
      }
    );

    alert(res.data.message);

    onContestClose();

    setSelectedContest("");
    setSelectedUser(null);

  } catch (err) {
    errorToast(
      err?.response?.data?.message || "Failed"
    );
  }
};

const handleUpdateUserStatus = async () => {
  if (!selectedStatusUser) {
    return errorToast("No user selected for status update");
  }

  try {
    setStatusUpdateLoading(true);

    const payload = {
  userId: selectedStatusUser._id,
  userMessageEng: statusMessageEng,
  userMessageHindi: statusMessageHindi,

  onHold: statusAction === "onHold"
    ? !selectedStatusUser.onHold
    : false,

  terminateUser: statusAction === "terminate"
    ? !selectedStatusUser.terminateUser
    : false,
};
//     if (statusAction === "onHold") {
//   payload.onHold = true;
// } else if (statusAction === "terminate") {
//   payload.terminateUser = true;
// }

    const res = await axios.put("/updateUserAccountStatus", payload);

    toast(res.data.message || "Status updated successfully");
    onStatusClose();
    setStatusAction("onHold");
    setStatusMessageEng("");
    setStatusMessageHindi("");
    setSelectedStatusUser(null);
    fetchUsers(activeTab, page);
  } catch (err) {
    errorToast(
      err?.response?.data?.message || "Failed to update user status"
    );
  } finally {
    setStatusUpdateLoading(false);
  }
};

const openStatusModal = (user, action) => {
  setSelectedStatusUser(user);
  setStatusAction(action);
  setStatusMessageEng(user.userMessageEng || "");
  setStatusMessageHindi(user.userMessageHindi || "");
  onStatusOpen();
};

  const columns = React.useMemo(
    () => [
{
  Header: "Sr No.",
  accessor: "srNo",
  Cell: ({ row: { index } }) => (
    <Cell text={(page - 1) * apiPageSize + index + 1} />
  ),
},
      {
        Header: "User",
        accessor: "name",
        Cell: ({ value, row: { original } }) => (
          <>
            <UserNameLink
              userId={original?._id}
              name={value}
              planName={original?.planName}
              email={original?.email}
            />
            <div className="flex items-center justify-center gap-2 text-13 mt-2">
              <div className="flex gap-2 ">
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-green-600 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-green">
                    {original?.quizStats?.totalRight}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-redC rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-red">
                    {original?.quizStats?.totalWrong}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-yellow-400 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-yellow-500">
                    {original?.quizStats?.totalSkipped}
                  </h1>
                </div>
              </div>
              {/* <div className="py-1 shadow-md px-2 bg-bgWhite text-black border-1 border-coolGray rounded-lg flex flex-col-2 gap-2 items-center justify-items-center">
                <Image
                  alt="Rate"
                  src={rateIcon}
                  width={20}
                  height={20}
                  layout="fixed"
                />

                <div className="text-center">
                  {original?.planName === "Silver"
                    ? 3000
                    : original?.planName === "Silver Plus"
                    ? 2000
                    : original?.planName === "Gold"
                    ? 1500
                    : original?.planName === "Platinum"
                    ? 1000
                    : 3000}
                  /1$
                </div>
              </div> */}
            </div>
          </>
        ),
      },

      {
        Header: "Ammount Paid",
        accessor: "amount",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={`Rs. ${value}`} className="font-bold text-green-600"  />
          </>
        ),
      },
      {
        Header: "Mobile No.",
        accessor: "mobile",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={<MobileContactMenu mobile={original.mobile} />} />
          </>
        ),
      },
      // {
      //   Header: "PaymentMethod",
      //   accessor: "paymentMethod",
      //   Cell: ({ value, row: { original } }) => (
      //     <>
      //       <Cell text={value==null?"Other":`${value}`} />
      //     </>
      //   ),
      // },
      {
        Header: "Plan",
        accessor: "planName",
        Cell: ({ value, row: { original } }) => <Cell text={original.planName} />,
      },

      {
        Header: "Created On",
        accessor: "createdOn",
        Cell: ({ value, row: { original } }) => (
          <Cell text={dayjs(value).format("D MMM, YYYY h:mm A")} />
        ),
      },
      {
        Header: "Total Earning (Credits)",
        accessor: "unifiedWallet.balance",
        Cell: ({ value, row: { original } }) => (
          <Cell text={`${Math.ceil(value)}`} />
        ),
      },
      // {
      //   Header: "Wallet Balance (Rs.)",
      //   accessor: "currentEarning",
      //   Cell: ({
      //     value,
      //     row: {
      //       original: { rate, rightCount },
      //     },
      //   }) => {
      //     return <Cell text={`Rs. ${Math.round(rightCount * rate)}`} />;
      //   },
      // },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row: { original } }) => {
          return (
            <>
              <Menu>
                <MenuButton
                  as={Button}
                  className="bg-purple "
                  colorScheme="bgBlue"
                  onClick={() => setNewID(original._id)}
                >
                  Actions
                </MenuButton>
                <MenuList>
                  <Link to={`/dash/view-user/${original._id}`}>
                    <MenuItem>
                      {" "}
                      <GrView className="mr-4" /> View
                    </MenuItem>
                  </Link>
                  <Link to={`/dash/edit-user/${original._id}`}>
                    <MenuItem>
                      {" "}
                      <MdEdit className="mr-4" /> Edit
                    </MenuItem>
                  </Link>

                  <MenuItem
                    onClick={() => {
                      setSelectedStatusUser(original);
                      setStatusAction("onHold");
                      onStatusOpen();
                    }}
                  >
                    {" "}
                    <HiStatusOnline className="mr-4" /> Hold User
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      setSelectedStatusUser(original);
                      setStatusAction("terminate");
                      onStatusOpen();
                    }}
                  >
                    {" "}
                    <MdDelete className="mr-4" /> Terminate User
                  </MenuItem>

                 <MenuItem
                   onClick={() => {
                     setSelectedUser(original);
                     onContestOpen();
                   }}
                 >
                   <MdWhatsapp className="mr-4"/> send Contest Message
                 </MenuItem>
                <MenuItem
  onClick={() => {
    setSelectedUser(original._id);
    setCurrentPlan(original.plan);
    onPlanOpen();
  }}
>
  <GrOverview className="mr-4" />
  Change Plan
</MenuItem>
<MenuItem
  color="red.500"
  onClick={() => {
    setSelectedUser(original._id);
    onOpen(); // Delete confirmation modal
  }}
>
  <MdDelete className="mr-4" />
  Delete User
</MenuItem>
                </MenuList>
              </Menu>
            </>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [apiPageSize, page],
  );

  return (
    <div
      className="lg:py-8 py-4 bg-bgBlue"
      style={{
        backgroundImage: `url('${bgImage}')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <section className="px-2 py-3 md:p-1">
        <div className="py-4">
          <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
            {/* <div>
              <h2 class="text-xl font-bold  mb-4 text-purple text-oswald pl-5">
                Active User
              </h2>
            </div> */}
           <div
  className={`bg-gradient-to-r ${currentStats.gradient} text-white rounded-xl p-5 shadow-lg mb-4`}
>
  <p className="text-sm opacity-90">
    {currentStats.title}
  </p>

  <h2 className="text-3xl font-bold">
    {currentStats.count}
  </h2>
</div>
         <Tabs
  variant="soft-rounded"
  colorScheme="purple"
  className="w-full xl:w-auto"
  onChange={(index) => {
    setPage(1);

    if (index === 0) setActiveTab("all");
    if (index === 1) setActiveTab("paid");
    if (index === 2) setActiveTab("demo");
  }}
>
              <TabList mb={0} flexWrap="wrap" gap={2}>
                <Tab className="flex-1 whitespace-nowrap bg-purple-100 text-white sm:flex-none">All Users</Tab>
                <Tab className="flex-1 whitespace-nowrap bg-purple-100 text-white sm:flex-none">Active Users</Tab>
                <Tab className="flex-1 whitespace-nowrap bg-purple-100 text-white sm:flex-none">New Users</Tab>
              </TabList>
            </Tabs>
            {/* <Button
  colorScheme="green"
  onClick={async () => {
    try {
      const res = await axios.get(
        "exportTodayUsers"
      );

      alert(
        `${res.data.totalUsers} users exported`
      );
    } catch (err) {
      alert("Export failed");
    }
  }}
>
  Export Today's Users
</Button> */}
{/* <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-center xl:w-auto">
  <input
    type="date"
    value={startDate}
    onChange={(e) => setStartDate(e.target.value)}
    className="w-full rounded border p-2 sm:w-auto"
  />

  <input
    type="date"
    value={endDate}
    onChange={(e) => setEndDate(e.target.value)}
    className="w-full rounded border p-2 sm:w-auto"
  />

  <button
    onClick={exportUsers}
    className="w-full rounded bg-green-600 px-4 py-2 text-white sm:w-auto"
  >
    Export Sheet
  </button>
</div> */}
<div className="flex flex-wrap items-center gap-3">
    <UserTableControls
        search={search}
        onSearchChange={setSearch}
        sortOptions={userSortOptions}
        onSortChange={setSortBy}
    />
<div className="flex flex-wrap items-center gap-2">

  <label htmlFor="active-users-start-date" className="text-sm text-gray-600">From Date</label>
  <input
    id="active-users-start-date"
    type="date"
    value={startDate}
    max={endDate || undefined}
    onChange={(e) => setStartDate(e.target.value)}
    className="border rounded px-2 py-2"
  />

  <label htmlFor="active-users-end-date" className="text-sm text-gray-600">To Date</label>
  <input
    id="active-users-end-date"
    type="date"
    value={endDate}
    min={startDate || undefined}
    onChange={(e) => setEndDate(e.target.value)}
    className="border rounded px-2 py-2"
  />

  <Button
    size="sm"
    colorScheme="red"
    onClick={() => {
      setStartDate("");
      setEndDate("");
    }}
  >
    Clear
  </Button>

</div>
    <Button
      colorScheme="green"
      onClick={onMessageOpen}
    >
      Send Contest Message
    </Button>
</div>
            {/* <div className=" w-96">
              <InputGroup borderRadius={5} size="sm">
                <InputLeftElement
                  pointerEvents="none"
                  // children={<Search2Icon color="gray.600" />}
                />
               <Input
  type="text"
  placeholder="Search..."
  border="1px solid #949494"
  value={search}
  onChange={(e) => setSearch(e.target.value)}
/>
                <InputRightAddon p={0} border="none">
                  <Button
                    className="bg-purple"
                    colorScheme="#FF782D"
                    size="sm"
                    borderLeftRadius={0}
                    borderRightRadius={3.3}
                    border="1px solid #949494"
                  >
                    Search
                  </Button>
                </InputRightAddon>
              </InputGroup>
            </div> */}

            {/* <div className="flex gap-2">
              <Menu>
                <MenuButton
                  as={Button}
                  colorScheme="#4D2C5E"
                  zIndex={20}
                  className="bg-bgBlue"
                >
                  Sort By
                </MenuButton>
               <MenuList>
  <MenuItem onClick={() => setSortBy("latest")}>
    Latest First
  </MenuItem>
  <MenuItem onClick={() => setSortBy("oldest")}>
    Oldest First
  </MenuItem>
  <MenuItem onClick={() => setSortBy("amountHigh")}>
    Amount High → Low
  </MenuItem>
  <MenuItem onClick={() => setSortBy("amountLow")}>
    Amount Low → High
  </MenuItem>
</MenuList>
              </Menu>
              <Menu>
                <MenuButton
                  as={Button}
                  colorScheme="#FF782D"
                  zIndex={20}
                  className="bg-purple"
                  ref={btnRef}
                  onClick={onOpen2}
                >
                  Filter By
                </MenuButton>
              </Menu>
            </div> */}
            <Drawer
              isOpen={isOpen2}
              placement="right"
              onClose={onClose2}
              finalFocusRef={btnRef}
            >
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Create your account</DrawerHeader>

             <DrawerBody>
  {/* TYPE FILTER */}
  <select
    className="w-full border p-2 rounded mb-4"
    onChange={(e) => setFilterType(e.target.value)}
  >
    <option value="">All</option>
    <option value="course">Only Course</option>
    <option value="contest">Only Contest</option>
    <option value="both">Both</option>
  </select>

  {/* CONTEST FILTER */}
<select
  className="w-full border p-2 rounded"
  value={selectedContest}
  onChange={(e) => setSelectedContest(e.target.value)}
>
  <option value="">All Contest</option>

  {contestList.map((contest) => (
 <option key={contest._id} value={contest._id}>
  {contest.contestName} (
  {moment(contest.startTime).format("DD MMM YYYY")} |{" "}
  {contest.StartTime ? moment(contest.startTime).format("hh:mm A") : "N/A"} -{" "}
  {contest.EndTime ? moment(contest.endTime).format("hh:mm A") : "N/A"}
  )
</option>
))}
</select>
</DrawerBody>

                <DrawerFooter>
                  <Button variant="outline" mr={3} onClick={onClose2}>
                    Cancel
                  </Button>
                  <Button colorScheme="blue">Save</Button>
                </DrawerFooter>
              </DrawerContent>
            </Drawer>

            {/* send message to single user by selecting contest */}
             <Drawer
              isOpen={isContestOpen}
              placement="right"
              onClose={onContestClose}
            >
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
            
                <DrawerHeader>
                  Send Contest WhatsApp
                </DrawerHeader>
            
                <DrawerBody>
            
                  <p className="mb-3 font-semibold">
                    {selectedUser?.name}
                  </p>
            
                  <Select
                    placeholder="Select Contest"
                    value={selectedContest}
                    onChange={(e) => setSelectedContest(e.target.value)}
                  >
                    {contestList.map((contest) => (
                      <option key={contest._id} value={contest._id}>
                        {contest.contestName}
                      </option>
                    ))}
                  </Select>
            
                </DrawerBody>
            
                <DrawerFooter>
                  <Button
                    mr={3}
                    onClick={onContestClose}
                  >
                    Cancel
                  </Button>
            
                  <Button
                    colorScheme="green"
                    onClick={sendSingleContestMessage}
                  >
                    Send
                  </Button>
                </DrawerFooter>
              </DrawerContent>
            </Drawer>

          </div>
          <div className="mt-2 w-full">
            <div className="hidden overflow-x-auto md:block">
              <Table
                columns={columns}
                data={processedData}
                total={totalUsers || processedData.length }
                pageSize={apiPageSize}
                pageCount={totalPages}
                currentPage={page}
                onPageChange={setPage}
              />
            </div>

            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:hidden">
              {processedData.map((user, index) => (
              <UserCard
  key={user._id}
  user={user}
  serialNumber={(page - 1) * apiPageSize + index + 1}
  onHoldUser={(user) => {
    setNewID(user._id);
    onOpen2();
  }}
  onChangePlan={(user) => {
    setSelectedUser(user._id);
    setCurrentPlan(user.plan);
    onPlanOpen();
  }}
  onDeleteUser={(user) => {
    setSelectedUser(user._id);
    onOpen(); // Delete confirmation dialog
  }}
/>
              ))}
            </div>

            {processedData.length === 0 && (
              <div className="rounded-lg bg-white p-8 text-center text-gray-500 md:hidden">
                No users found.
              </div>
            )}

            {totalPages > 1 && (
              <div className="mt-5 flex justify-center md:hidden">
                <PaginationNav
                  pageIndex={page}
                  pageCount={totalPages}
                  onPageChange={setPage}
                />
              </div>
            )}
          </div>
        </div>
      </section>
      <ChangePlanModal
  isOpen={isPlanOpen}
  onClose={onPlanClose}
  userId={selectedUser}
  currentPlan={currentPlan}
  onSuccess={() => fetchUsers(activeTab, page)}
/>
<Drawer
  isOpen={isMessageOpen}
  placement="right"
  onClose={onMessageClose}
>
  <DrawerOverlay />

  <DrawerContent>
    <DrawerCloseButton />

    <DrawerHeader>
      Send Contest WhatsApp Message
    </DrawerHeader>

    <DrawerBody>

      <label>From Date</label>

      <input
  type="date"
  className="w-full border rounded p-2 mb-4"
  value={messageStartDate}
  onChange={(e) => {
    const value = e.target.value;
    setMessageStartDate(value);
    fetchUserCount(value, messageEndDate);
  }}
/>

      <label>To Date</label>

     <input
  type="date"
  className="w-full border rounded p-2 mb-4"
  value={messageEndDate}
  onChange={(e) => {
    const value = e.target.value;
    setMessageEndDate(value);
    fetchUserCount(messageStartDate, value);
  }}
/>
<div className="mb-4 p-3 rounded bg-gray-100 border">
  {countLoading ? (
    <p>Loading user count...</p>
  ) : (
    <p className="font-semibold">
      Total Users: <span className="text-green-600">{userCount}</span>
    </p>
  )}
</div>
      <label>Select Contest</label>

      <select
        className="w-full border rounded p-2"
        value={selectedMessageContest}
        onChange={(e) =>
          setSelectedMessageContest(e.target.value)
        }
      >
        <option value="">
          Select Contest
        </option>

        {contestList.map((contest) => (
          <option
            key={contest._id}
            value={contest._id}
          >
            {contest.contestName}
          </option>
        ))}
      </select>

    </DrawerBody>

    <DrawerFooter>

      <Button
        mr={3}
        variant="outline"
        onClick={onMessageClose}
      >
        Cancel
      </Button>

      <Button
        colorScheme="green"
        onClick={sendContestMessage}
      >
        Send Message
      </Button>

    </DrawerFooter>

  </DrawerContent>
</Drawer>

<Modal isOpen={isStatusOpen} onClose={onStatusClose} isCentered size="md">
  <ModalOverlay />
  <ModalContent>
   <ModalHeader>
  {statusAction === "terminate"
    ? selectedStatusUser?.terminateUser
      ? "Remove User Termination"
      : "Terminate User"
    : selectedStatusUser?.onHold
      ? "Remove Hold"
      : "Hold User"}
</ModalHeader>
    <ModalCloseButton />
    <ModalBody>
      <div className="space-y-4">
        <div>
          <p className="font-semibold">Selected User</p>
          <p>{selectedStatusUser?.name || selectedStatusUser || "-"}</p>
        </div>

        <div>
          <label className="font-semibold block mb-2">
            English Message
          </label>
          <Textarea
            placeholder="Enter message in English"
            value={statusMessageEng}
            onChange={(e) => setStatusMessageEng(e.target.value)}
            rows={4}
          />
        </div>

        <div>
          <label className="font-semibold block mb-2">
            Hindi Message
          </label>
          <Textarea
            placeholder="Enter message in Hindi"
            value={statusMessageHindi}
            onChange={(e) => setStatusMessageHindi(e.target.value)}
            rows={4}
          />
        </div>
      </div>
    </ModalBody>
    <ModalFooter>
      <Button mr={3} onClick={onStatusClose}>
        Cancel
      </Button>
    <Button
  colorScheme={statusAction === "terminate" ? "red" : "yellow"}
  isLoading={statusUpdateLoading}
  onClick={handleUpdateUserStatus}
>
  {statusAction === "terminate"
    ? selectedStatusUser?.terminateUser
      ? "Remove Termination"
      : "Terminate User"
    : selectedStatusUser?.onHold
      ? "Remove Hold"
      : "Put On Hold"}
</Button>
    </ModalFooter>
  </ModalContent>
</Modal>
o
<DeletePasswordModal
  isOpen={isOpen}
  onClose={onClose}
  onConfirm={handleDeleteUser}
  title="Delete User"
  description="This will permanently delete the user. This action cannot be undone."
/>
    </div>
    
    
  );
}

export default ActiveUser;
